package compose.assets.svg

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.EvenOdd
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import compose.assets.Svg

public val Svg.ScreenLand: ImageVector
    get() {
        if (_screenLand != null) {
            return _screenLand!!
        }
        _screenLand = Builder(name = "ScreenLand", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp,
                viewportWidth = 24.0f, viewportHeight = 24.0f).apply {
            group {
                path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = EvenOdd) {
                    moveTo(9.559f, 16.716f)
                    lineTo(3.511f, 16.716f)
                    curveTo(2.47f, 16.716f, 1.625f, 15.871f, 1.625f, 14.83f)
                    lineTo(1.625f, 14.83f)
                    lineTo(1.625f, 5.398f)
                    curveTo(1.625f, 4.356f, 2.47f, 3.511f, 3.511f, 3.511f)
                    lineTo(20.489f, 3.511f)
                    curveTo(21.53f, 3.511f, 22.375f, 4.356f, 22.375f, 5.398f)
                    lineTo(22.375f, 14.83f)
                    curveTo(22.375f, 15.871f, 21.53f, 16.716f, 20.489f, 16.716f)
                    lineTo(14.441f, 16.716f)
                    lineTo(14.441f, 18.047f)
                    lineTo(16.882f, 18.047f)
                    lineTo(16.882f, 20.489f)
                    lineTo(7.118f, 20.489f)
                    lineTo(7.118f, 18.047f)
                    lineTo(9.559f, 18.047f)
                    lineTo(9.559f, 16.716f)
                    close()
                    moveTo(6.341f, 12.943f)
                    lineTo(10.114f, 12.943f)
                    lineTo(10.114f, 11.528f)
                    lineTo(7.756f, 11.528f)
                    lineTo(7.756f, 9.17f)
                    lineTo(6.341f, 9.17f)
                    lineTo(6.341f, 12.943f)
                    lineTo(6.341f, 12.943f)
                    close()
                    moveTo(13.886f, 8.699f)
                    lineTo(16.244f, 8.699f)
                    lineTo(16.244f, 11.057f)
                    lineTo(17.659f, 11.057f)
                    lineTo(17.659f, 7.284f)
                    lineTo(13.886f, 7.284f)
                    lineTo(13.886f, 8.699f)
                    lineTo(13.886f, 8.699f)
                    close()
                    moveTo(4.455f, 14.83f)
                    lineTo(4.455f, 5.398f)
                    lineTo(19.545f, 5.398f)
                    lineTo(19.545f, 14.83f)
                    lineTo(4.455f, 14.83f)
                    lineTo(4.455f, 14.83f)
                    close()
                }
            }
        }
        .build()
        return _screenLand!!
    }

private var _screenLand: ImageVector? = null
